import axios from 'axios'
import {handleError} from '../handleError'
import {PassRule} from "../../object";

const state = {}
const getters = {}
const mutations = {}
const actions = {
  async getSelfInfo({dispatch}){
    let url = "/shiroApi/selfInfo"
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async apply({dispatch},params){
    let url = '/passObjectApi/temp/audit'
    try {
      let res = null
      res = await axios.post(url,params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async importTeachers({dispatch},params){
    let url = '/passObjectApi/temp/audits'
    try {
      let res = null
      res = await axios.post(url,params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async deleteTeachers({dispatch},params){
    let url = '/passObjectApi/temp/audits'
    try {
      let res = null
      res = await axios.delete(url,{data:params})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async firstReview({dispatch},params){
    let url = '/passObjectApi/temp/audit/first'
    try {
      let res = null
      res = await axios.post(url,params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async secondReview({dispatch},params){
    let url = '/passObjectApi/temp/audit/second'
    try {
      let res = null
      res = await axios.post(url,params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getNeedSignList ({dispatch}, {pagination, sortStack, search, filter}) {
    let url =   '/authSlot/healStatusList/?code='+search.value
    let res = await  axios.get(url)
    return res
  },
  async getApplyList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passObjectApi/temp/audit/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async getTeacherList({dispatch},{pagination,params}){
    let url = "/passObjectApi/temp/audit/list?page="+(pagination.page-1)+
      "&size="+pagination.rowsPerPage
    try {
      let res = await axios.post(url,params)
      if(res.data.status === 1){
        return {items:res.data.data.content,amount:res.data.data.totalElements}
      }else{
        return {items:[],amount:0}
      }
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getFileTemplate(){
    return encodeURI("https://smaco2.uestc.edu.cn/pipe/files/防疫期间轮班职工名单（××学院）.xlsx")
  },
  async getBlackAndWhiteFile(){
    return encodeURI("https://smaco2.uestc.edu.cn/pipe/files/白名单-黑名单导入模板.xlsx")
  },
  async addWhite({dispatch},params){
    let url = '/passObjectApi/temp/audit/to/white'
    try {
      let res = null
      res = await axios.post(url,params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async addBlack({dispatch},params){
    let url = '/passObjectApi/temp/audit/to/black'
    try {
      let res = null
      res = await axios.post(url,params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async addRecord({dispatch},params){
    let url = '/authSlot/normalizeStatus'
    try {
      let res = null
      let config = {method:'put', url, params}
      // console.log('axios', config)
      res = await axios(config)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async applyExtraSign({dispatch},params) {
    let res = await axios.post("/passObjectApi/temp/normalize",params)
    return res
  },
  async getExtraSignList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passObjectApi/temp/normalize/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async reviewExtraSign({dispatch},{params,type}){
    let typeMap = {
      '1':'first',
      '2':'medicine',
      '3':'second'
    }
    let url = "/passObjectApi/temp/normalize/audit/"+typeMap[type]
    let res = await axios.post(url,params)
    return res
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
